import { createInMemoryAtom } from '@exodus/atoms';
export var ErrorCode;
(function (ErrorCode) {
    ErrorCode["StateUnavailable"] = "StateUnavailable";
    ErrorCode["StateMaybeUnavailable"] = "StateMaybeUnavailable";
    ErrorCode["RegionUnavailable"] = "RegionUnavailable";
    ErrorCode["CountryUnavailable"] = "CountryUnavailable";
    ErrorCode["TemporarilyUnavailable"] = "TemporarilyUnavailable";
})(ErrorCode || (ErrorCode = {}));
Object.setPrototypeOf(ErrorCode, null);
const createExchangeAvailabilityAtom = () => createInMemoryAtom({ defaultValue: null });
export default createExchangeAvailabilityAtom;
